export default __webpack_public_path__ + "static/media/stage_bird.fc12eb38.svg";